// extracted by mini-css-extract-plugin
export default {"top-card":"IrNzy","title":"QkkFl","form":"WENz5","input-container":"q1xLJ","button-container":"b7CCb"};